import { Store } from 'vuex';
import { PRODUCT_NAME } from '@/constants';
import { RootState } from '@/stores/pcStore';
import { StorageType } from '@/types';

export interface StorageDetails {
  status: StorageStatus;
  isConnected: boolean;
  isLoaded: boolean;
  fileCount: string;
  syncStartedAt: string;
  syncEndedAt: string;
}

export type StorageStatus =
  | 'FETCH_ERROR' /** 取得失敗 */
  | 'NOT_CONNECTED' /** 未連携 */
  | 'CONNECT_FAILED' /** 連携失敗 */
  | 'SYNCING' /** 同期中 */
  | 'SYNCED' /** 同期処理終了 */
  | 'CREDENTIAL_INVALID'; /** 認証情報不正 */

export interface UseStorage {
  /** 連携メソッド */
  connect: (item: StorageDetails) => void;
  /** 連携解除メソッド。モーダルに提供するため、関数を返す */
  disconnect: (item: StorageDetails) => () => void;
  /** 状態更新 */
  updateDetails: (item: StorageDetails) => void;
}

export type AdminTableItem = {
  id: number;
  storageType: StorageType;
  connectText: string;
  syncStatus: string;
} & StorageDetails;

export const ACTION_BLOCKED_STATUSES: StorageStatus[] = [
  'SYNCING',
  'FETCH_ERROR',
];

export const isUncertified = (item: StorageDetails) =>
  !item.isConnected || item.status === 'CREDENTIAL_INVALID';

export const displayStorageStatus = (item: StorageDetails) =>
  isUncertified(item) ? '未認証' : '認証済み';

export const displaySyncStatus = (item: StorageDetails) => {
  if (!item.isConnected) {
    return '-';
  }
  switch (item.status) {
    case 'SYNCED':
      return '同期処理終了';
    case 'SYNCING':
      return '同期処理中';
    case 'CREDENTIAL_INVALID':
      return '-';
    default:
      return '-';
  }
};

export const isSynced = (status: StorageStatus) => {
  return status === 'SYNCED';
};

export const isSyncing = (status: StorageStatus) => {
  return status === 'SYNCING';
};

export const isConnectedFailed = (status: StorageStatus) => {
  return status === 'CONNECT_FAILED';
};

export const showDisconnectModal = (
  store: Store<RootState>,
  item: StorageDetails,
  action: () => void,
) => {
  const payload = {
    headerText: 'ストレージの認証解除',
    bodyText: `ストレージの認証を解除しますか？認証を解除すると${PRODUCT_NAME}で社内情報を検索できなくなります。`,
    action,
    btnText: '解除',
    isBtnDisabled: ACTION_BLOCKED_STATUSES.includes(item.status),
    warningText: ACTION_BLOCKED_STATUSES.includes(item.status)
      ? '現在はストレージの認証を解除できません'
      : '',
  };
  store.commit('confirmationModal/showConfirmationModal');
  store.commit('confirmationModal/setTextAndAction', payload);
};
